import { dataToFormData } from "../../Utils/helper";
import { del, get, patch, patchImage, post, postImage } from "./ApiServices";

const getDashboardService = async () => {
  let response = await get(`/user/dashboard/`);
  return response;
};
const getUsersService = async ({ data }) => {
  let { offset, name } = data;
  let response = await get(
    `/user/?limit=7&offset=${offset ?? 0}${name?.length ? `&name=${name}` : ""}`
  );
  return response;
};

const getCourseUsersService = async ({ data }) => {
  let { course_id } = data;
  let response = await get(`/course/${course_id}/users`);
  return response;
};

const getCourseMessagesService = async ({ data }) => {
  let { course_id } = data;
  // console.log(
  //   "getCourseMessagesService",
  //   data,
  //   course_id,
  //   data?.course_id,
  //   `/chat/?course_id=${course_id}`
  // );

  let response = await get(`/chat/?course_id=${data?.course_id}`);
  return response;
};

const getAdminsService = async () => {
  let response = await get(`/user/admins/`);
  return response;
};

const postFolderService = async ({ data }) => {
  let response = await post(`/course/folder/`, data);
  return response;
};

const getCoursesService = async ({ offset, limit, search, category }) => {
  let response = await get(
    `/course/registered/?limit=${limit ?? 4}&offset=${offset?.offset ?? 0}${
      search?.length ? `&search=${search}` : ""
    }${category?.length ? `&category=${category}` : ""}`
  );
  return response;
};

const getNewCoursesService = async ({ offset, search, category }) => {
  let response = await get(
    `/course/popular/?limit=4&offset=${offset?.offset ?? 0}${
      search?.length ? `&search=${search}` : ""
    }${category?.length ? `&category=${category}` : ""}`
  );
  return response;
};
const getWaitingCoursesService = async ({ offset, search, category }) => {
  let response = await get(
    `/course/waiting/approval/?limit=4&offset=${offset?.offset ?? 0}${
      search?.length ? `&search=${search}` : ""
    }${category?.length ? `&category=${category}` : ""}`
  );
  return response;
};

const getCourseEnrollReqService = async ({ data }) => {
  let { course_id, offset, name } = data;
  let response = await get(
    `/course/requests/${course_id}/?offset=${offset ?? 0}&limit=7${
      name ? `&name=${name}` : ""
    }`
  );
  return response;
};

const postCourseService = async ({ data }) => {
  let formData = dataToFormData(data);
  let response = await postImage(`/course/`, formData);
  return response;
};

const patchCourseService = async ({ data }) => {
  let { course_id } = data;
  delete data["course_id"];
  delete data["folder_name"];
  delete data["folder_id"];

  let formData = dataToFormData(data);
  // console.log("dara", formData, data, course_id);

  let response = await patchImage(`/course/?course_id=${course_id}`, formData);
  return response;
};

const patchContentReorderService = async ({ id, data }) => {
  let response = await patch(`/course/${id}/content/order/`, data);
  return response;
};

const deleteCourseService = async ({ data }) => {
  let { id } = data;
  let response = await del(`/course/?course_id=${id}`);
  return response;
};

const postCourseEnrollService = async ({ data }) => {
  let response = await post(`/student/enroll/`, data);
  return response;
};

const postApproveReqService = async ({ data }) => {
  let response = await post(`/instructor/course/approval/`, data);
  return response;
};
const postQuizService = async ({ data }) => {
  let response = await post(`/course/createquiz/`, data);
  return response;
};

const getQuizDetailsService = async ({ id }) => {
  let response = await get(`/course/quiz/${id}/result/`);
  return response;
};
const getContentService = async ({ id, con_type, offset }) => {
  let response = await get(
    `/course/${id}/content/order?limit=7&offset=${offset ?? 0}`
  );
  return response;
};

const postContentService = async ({ data }) => {
  // let formData = dataToFormData(data);
  let response = await postImage(`/course/add/content/`, data);
  return response;
};

const postSubmitQuizService = async ({ data }) => {
  let response = await postImage(`/course/submit-quiz/`, data);
  return response;
};

const deleteContentService = async ({ data }) => {
  let { id, type } = data;
  let response = await del(`/course/${type}/${id}/`);
  return response;
};
const deleteFolderService = async ({ data }) => {
  let { id } = data;
  let response = await del(`/course/folder/?folder_id=${id}`);
  return response;
};

const getNewsService = async () => {
  let response = await get(`/user/news/`);
  return response;
};
const getDownloadedNewsService = async () => {
  let response = await get(`/user/news/?downloaded=true`);
  return response;
};

const postNewsService = async ({ data }) => {
  let response = await post(`/user/download/news/`, data);
  return response;
};
const getAllContentsService = async (data) => {
  let response = await get(`/course/${data?.id}/content/order/`);
  return response;
};
const getSlugService = async () => {
  let response = await get(`/course/slug/`);
  return response;
};

const getMailService = async ({ mail_type, bool }) => {
  // console.log("getMailService", mail_type,`/chat/i-mail/${mail_type ? `?${mail_type}=true` : ""}`);
  let response = await get(
    `/chat/i-mail/${mail_type ? `?${mail_type}=${bool}` : ""}`
  );
  return response;
};

const sendMailService = async ({ data }) => {
  let response = await post(`/chat/i-mail/`, data);
  return response;
};

const readMailService = async ({ data }) => {
  let data1 = { unread: false };
  let response = await patch(`/chat/i-mail/${data}/`, data1);
  return response;
};
const getS3UrlService = async ({ data }) => {
  let response = await patch(`/course/content/s3/url/`, data);
  return response;
};

const deleteMailService = async ({ id, permanent_delete }) => {
  // console.log('deleteMailService',permanent_delete, `/chat/i-mail/${id}/${permanent_delete ? `?permanent_delete=true` : ""}`);

  let response = await del(
    `/chat/i-mail/${id}${permanent_delete ? `/?permanent_delete=true` : ""}`
  );
  return response;
};

const stripeOnboardService = async ({ data }) => {
  let data1 = {
    return_url: `http://reflective-mastery2.surge.sh/${data}`,
    refresh_url: `http://reflective-mastery2.surge.sh/${data}`,
  };
  let response = await post(`/user/stripe/onboard/`, data1);
  return response;
};

export const homeServices = {
  getDashboardService,
  getUsersService,
  postFolderService,
  getCoursesService,
  getNewCoursesService,
  getWaitingCoursesService,
  postCourseService,
  getNewsService,
  getDownloadedNewsService,
  postNewsService,
  getContentService,
  postContentService,
  deleteContentService,
  deleteFolderService,
  postCourseEnrollService,
  patchCourseService,
  getCourseEnrollReqService,
  postApproveReqService,
  getMailService,
  sendMailService,
  readMailService,
  postQuizService,
  getQuizDetailsService,
  getAdminsService,
  deleteCourseService,
  postSubmitQuizService,
  getCourseUsersService,
  stripeOnboardService,
  getAllContentsService,
  getSlugService,
  deleteMailService,
  patchContentReorderService,
  getCourseMessagesService,
  getS3UrlService,
};
